@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/global.variables' as globalVariables;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/spacing.variables' as spacing;
@use '@ongov/ontario-design-system-global-styles/dist/styles/scss/1-variables/colours.variables' as colours;

.ontario-hint {
	color: colours.$ontario-greyscale-70;
	display: inline-block;
	margin: spacing.$spacing-0 spacing.$spacing-0 spacing.$spacing-4 spacing.$spacing-0;
	width: globalVariables.$full-width;
	max-width: globalVariables.$standard-width;

	p {
		margin-bottom: spacing.$spacing-4;

		&:first-of-type {
			margin-top: spacing.$spacing-0;
		}

		&:last-of-type {
			margin-bottom: spacing.$spacing-0;
		}
	}

	// Fractal component style coverage ↓
	// This is a fix to prevent auto-detection of phone numbers in Firefox & Safari on iPhone devices
	a[x-apple-data-detectors] {
		color: inherit;
		cursor: none;
		text-decoration: none;
	}
}
